// This file defines all user role constants for the application.
// Each role is represented by a unique integer value.
// These constants are used throughout the app for permission checks and role-based logic.
export const ROLE_ADMINISTRATOR = 1
export const ROLE_RIGHTSLINE_PRODUCT_GATE_CONTENT_SALES = 2
export const ROLE_BULK_DATE_MATH_TOOL = 3
export const ROLE_AIR_DATE_INGESTION_TOOL = 4
export const ROLE_WON_ERROR_REPORT = 5
export const ROLE_APOLLO_ERROR_REPORT = 6
export const ROLE_JOB_TRACKER = 7
export const ROLE_LEGAL_ADMIN = 8
export const ROLE_LEGAL_USER = 9
export const ROLE_DEAL_VERSIONING = 10
export const ROLE_PRODUCT_COMMENTS_ADMIN = 11
export const ROLE_TAP_USER = 12
export const ROLE_RIGHTSETS_USER = 13
export const ROLE_RIGHTSETS_ASSOCIATE_USER = 14
export const ROLE_PMX_USER = 15
export const ROLE_TAP_ADMIN = 16
export const ROLE_TV_LEGAL_ADMIN = 17
export const ROLE_DEAL_VERSIONING_READ_ONLY = 18
export const ROLE_RIGHTSLINE_PRODUCT_GATE_ESPN_PLUS = 19
export const ROLE_RIGHTSLINE_PRODUCT_GATE_ADMIN = 20
export const ROLE_RIGHTSLINE_PRODUCT_GATE_ESPN_PLUS_READ_ONLY = 21
export const ROLE_RL_IMPORT_TEMPLATE = 22
export const ROLE_DIGITAL_STORES = 23